import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

export const useGetColumns = () => {

    const columns = [
        {
            field: 'numeroPedido',
            headerName: 'N° Pedido',
            flex: 110,
            noPaddingHeader: true
        },
        {
            field: 'numeroDocumento',
            headerName: 'N° Documento',
            flex: 110
        },
        {
            field: 'factura',
            headerName: 'Factura',
            headerAlign: 'center',
            align: 'center',
            flex: 80
        },
        {
            field: 'remito',
            headerName: 'Remito',
            headerAlign: 'center',
            align: 'center',
            flex: 80
        },
        {
            field: 'minuta',
            headerName: 'Identificación',
            flex: 140
        },
        {
            field: 'numeroDocLegal',
            headerName: 'N° Legal',
            flex: 140
        },
        {
            field: 'enviado',
            headerName: 'Enviado',
            headerAlign: 'center',
            align: 'center',
            flex: 80
        },
        {
            field: 'message',
            headerName: 'Mensaje',
            flex: 280
        },
        {
            field: 'fecha',
            headerName: 'Fecha',
            type: 'date',
            flex: 100
        },
        {
            field: 'hora',
            headerName: 'Hora',
            headerAlign: 'left',
            align: 'left',
            noPadding: true,
            noPaddingHeader: true,
            flex: 80
        }
    ]

    const configuratedColumns = generateColumnsDefaultConfiguration(columns, true);

    return configuratedColumns;
}